import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import CloseOutlinedIcon from '@tenancy.nz/icons/CloseOutlined';
import {Box, Heading, IconButton, Paper, Text} from '@tenancy.nz/ui';
import ConfettiText from './confetti-text';

function ConfettiToast({
  autoHideDuration = 8000,
  children = undefined,
  onClose = undefined,
  onExited = undefined,
  open = false,
  title = undefined,
}) {
  const handleClose = (_, reason) => {
    if (reason === 'clickaway' || !onClose) {
      return;
    }
    onClose();
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      slotProps={{transition: {onExited}}}>
      <Paper
        inset="large"
        outlined
        sx={{
          position: 'relative',
          width: {xs: '100%', sm: 336},
          maxWidth: '100%',
          '&&': {
            boxShadow: '0 8px 12.457px 0 rgba(0, 0, 0, 0.20)',
          },
        }}>
        {onClose && (
          <Box sx={{position: 'absolute', top: 12, right: 12}}>
            <IconButton
              color="primary"
              aria-label="Close notification"
              onClick={() => onClose()}>
              <CloseOutlinedIcon />
            </IconButton>
          </Box>
        )}
        <Stack gap={2}>
          {!!title && (
            <Heading as="h3" gutterBottom={false} sx={{pr: 8}}>
              {title}
            </Heading>
          )}
          <ConfettiText loop>
            {typeof children === 'string' ? (
              <Text weight="400" variant="body2">
                {children}
              </Text>
            ) : (
              children
            )}
          </ConfettiText>
        </Stack>
      </Paper>
    </Snackbar>
  );
}

ConfettiToast.propTypes = {
  autoHideDuration: PropTypes.number,
  children: PropTypes.node,
  onClose: PropTypes.func,
  onExited: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.node,
};

ConfettiToast.defaultProps = {
  autoHideDuration: 8000,
  children: undefined,
  onClose: undefined,
  onExited: undefined,
  open: false,
  title: undefined,
};

export default ConfettiToast;
